// extracted by mini-css-extract-plugin
module.exports = {"title":"instruction_title__2dbAk","checkIcon":"instruction_checkIcon__3pTH0","crossIcon":"instruction_crossIcon__lt59i"};